<template>
  <div class="railroad">
    <div class="main_wrapper" :style="getTopStyle()">
      <div class="map_wrapper" ref="top">
        <div class="map" v-html="mapStyled" v-if="isMapReady" ref="map" :style="{'background-color': getColorByName('land')}"></div>
        <div class="cities" :style="{color: getColorByName('cities'), 'font-size': citiesFontSize}" ref="cities">
          <label class="narvik">Narvik</label>
          <label class="bodo">Bodø</label>
          <label class="mosjoen">Mosjøen</label>
          <label class="steinkjer">Steinkjer</label>
          <label class="grong">Grong</label>
          <label class="trondheim">Trondheim</label>
          <label class="hell">Hell</label>
          <label class="meraker">Meråker</label>
          <label class="storen">Støren</label>
          <label class="roros">Røros</label>
          <label class="andalsnes">Åndalsnes</label>
          <label class="dombas">Dombås</label>
          <label class="lillehamer">Lillehammer</label>
          <label class="gjovik">Gjøvik</label>
          <label class="hamar">Hamar</label>
          <label class="elverum">Elverum</label>
          <label class="kongsvinger">Kongsvinger</label>
          <label class="roa">Roa</label>
          <label class="bergen">Bergen</label>
          <label class="arna">Arna</label>
          <label class="flam">Flåm</label>
          <label class="myrdal">Myrdal</label>
          <label class="stavanger">Stavanger</label>
          <label class="honefoss">Hønefoss</label>
          <label class="oslo big">Oslo S</label>
<!--          <label class="sandvika">Sandvika</label>-->
          <label class="hokksund small">Hokksund</label>
          <label class="notodden">Notodden</label>
          <label class="drammen small">Drammen</label>
          <label class="ski">Ski</label>
          <label class="sarpsborg">Sarpsborg</label>
          <label class="kornsjo">Kornsjø</label>
          <label class="larvik">Larvik</label>
          <label class="skien small">Skien</label>
          <label class="fredrikstad small">Fredrikstad</label>
          <label class="tonsberg small">Tønsberg</label>
          <label class="kristiansand">Kristiansand</label>
          <label class="arendal">Arendal</label>
          <label class="nelaug">Nelaug</label>
        </div>
        <div class="current_year" :style="{color: getColorByName('text'), 'font-size': yearCurrentFontSize}" :key="currentYear">{{currentYear}}</div>
        <div class="current_text" :style="{color: getColorByName('text')}" v-html="currentText"></div>
      </div>
      <div class="nav_wrapper">
        <div class="navigation">
          <div v-for="(e, index) in dataset" class="event" @click="goYear(index)"><span class="mark" :class="{selected: e.year == currentYear}"></span>{{e.year}}</div>
        </div>
      </div>
    </div>
    <div class="legend">
      <div class="today" :style="{color: yearColor}">
        <span :style="{'background-color': yearColor}"></span>
        <label>{{linesToday}}</label>
      </div>
      <div class="ertms" :style="{color: ertmsColor}">
        <span :style="{'background-color': ertmsColor}"></span>
        <label>{{linesERTMS}}</label>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'Railroad',

    data () {
      return {
        topHeight: 800,
        citiesFontSize: '11px',
        yearCurrentFontSize: '70px',
        mapWidth: 3963,
        mapHeight: 5919,
        mapStyled: '',
        isMapReady: false,
        currentYear: 2019,
        currentText: 'Welcome to demo!',
        yearColor: '#000',
        ertmsColor: '#fff',
        linesToday: '',
        linesERTMS: '',
      }
    },

    computed: {
      colors () {
        return this.$parent.colors;
      },
      legend () {
        return this.$parent.legend;
      },
      mapData () {
        return this.$parent.mapData;
      },
      dataset () {
        return this.$parent.railroadEvents;
      },
    },

    mounted() {
      window.addEventListener('resize', this.resize);
      this.resize();
    },

    created() {
      this.prepareData();
    },

    destroyed() {
      window.removeEventListener('resize', this.resize);
    },

    methods: {

      resize() {
        if (this.$refs.top) {
          this.topHeight = (this.$refs.top.clientWidth * this.mapHeight / this.mapWidth) + 'px';
          let fc = 11, fy = 70;
          if (this.$refs.top.clientWidth < 400) {
            fc = 11;
            fy = 70;
          } else if (this.$refs.top.clientWidth >= 400 && this.$refs.top.clientWidth < 500) {
            fc = 12;
            fy = 90;
          } else if (this.$refs.top.clientWidth >= 500 && this.$refs.top.clientWidth < 600) {
            fc = 13;
            fy = 110;
          } else if (this.$refs.top.clientWidth >= 600 && this.$refs.top.clientWidth < 700) {
            fc = 14;
            fy = 140;
          } else if (this.$refs.top.clientWidth >= 700 && this.$refs.top.clientWidth < 800) {
            fc = 15;
            fy = 180;
          } else if (this.$refs.top.clientWidth >= 800) {
            fc = 16;
            fy = 200;
          }
          this.citiesFontSize = fc + 'px';
          this.yearCurrentFontSize = fy + 'px';
        }
      },

      getTopStyle() {
        return {height: this.topHeight};
      },

      async prepareData() {
        if (this.dataset.length && this.colors) {
          // set stroke/fill colors according to loaded settings
          this.mapStyled = this.mapData;
          this.mapStyled = this.mapStyled.replace(new RegExp('{{SEA_COLOR}}', 'g'), this.colors.sea.hex8);
          this.mapStyled = this.mapStyled.replace(new RegExp('{{BORDER_COLOR}}', 'g'), this.colors.border.hex8);
          this.mapStyled = this.mapStyled.replace(new RegExp('{{PLANNED_COLOR}}', 'g'), this.colors.lines.hex8);
          for (let r of this.dataset) {
            this.mapStyled = this.mapStyled.replace(new RegExp('{{YEAR_' + r.year + '}}', 'g'), r.color.hex8);
            this.ertmsColor = r.color.hex8;
          }
          this.yearColor = this.colors.lines.hex8;
          this.isMapReady = true;
          await this.$nextTick();
          this.currentYear = this.dataset[0].year;
          this.currentText = this.$parent.language == 'eng' ? this.dataset[0].text_eng : this.dataset[0].text_nor;
          this.linesToday = this.legend.linesToday[this.$parent.language];
          this.linesERTMS = this.legend.linesERTMS[this.$parent.language];
          this.refresh();
        }
      },

      getColorByName(name) {
        return this.colors[name] ? this.colors[name].hex8 : '#000';
      },

      goYear(index) {
        if (index <= this.dataset.length) {
          this.currentYear = this.dataset[index].year;
          this.currentText = this.$parent.language == 'eng' ? this.dataset[index].text_eng : this.dataset[index].text_nor;
          this.refresh();
        }
      },

      refresh() {
        if (this.$refs.map) {
          for (let yg of this.$refs.map.getElementsByClassName('year')) {
            for (let cl of yg.classList) {
              if (cl.startsWith('year-')) {
                let val = parseInt(cl.replace('year-', ''));
                if (val <= this.currentYear) {
                  if (! yg.classList.contains('show')) {
                    yg.classList.add('show');
                    yg.classList.add('blink');
                  }
                } else {
                  if (yg.classList.contains('show')) {
                    yg.classList.remove('show');
                    yg.classList.remove('blink');
                  }
                }
              }
            }
          }
          setTimeout(() => this.cleanYears(), 250);
        }
      },

      cleanYears() {
        for (let yg of this.$refs.map.getElementsByClassName('year')) {
          yg.classList.remove('blink');
        }
      },

      getMultilineText(text, nl2br = true) {
        let encDiv = document.createElement('div');
        encDiv.innerText = text;
        return nl2br ? encDiv.innerHTML.replace("\n", '<br>') : encDiv.innerHTML;
      },
    },

  }
</script>

<style lang="less">
  @scene_bg_color: #000B41;
  @nav_bg_color: #2D2D87;

  .railroad {
    position: relative;
    width: 100%;

    .main_wrapper {
      position: relative;
      width: 100%;
      height: 100px;
      display: flex;
      flex-flow: row nowrap;
    }

    .map_wrapper {
      position: relative;
      width: 100%;
      height: 100%;
      overflow: hidden;
    }

    .nav_wrapper {
      position: relative;
      width: 40px;
      .navigation {
        display: flex;
        flex-flow: column nowrap;
        justify-content: space-between;
        align-items: center;
        background-color: @nav_bg_color;
        height: 100%;
        padding: 30px 0;
        box-sizing: border-box;
        .event {
          position: relative;
          font-size: 11px;
          padding-bottom: 5px;
          box-sizing: border-box;
          .mark {
            display: block;
            width: 25px;
            height: 25px;
            border-radius: 50%;
            background-color: @scene_bg_color;
            &.selected {
              background-color: #fff;
            }
          }
        }
      }
    }

    .map {
      position: relative;
      width: 100%;
      height: 100%;
      overflow: hidden;
      svg {
        position: absolute;
        height: 100%;
        left: -2px;
      }
      .year {
        //transition: opacity 250ms ease-out, stroke-width 150ms ease-in-out;
        transition: opacity 250ms ease-out, stroke-width 250ms cubic-bezier(0.340, -0.480, 0.5, 2.0);
        opacity: 0;
        &.show {
          opacity: 1;
        }
        &.blink {
          stroke-width: 21px;
        }
      }
    }

    .cities {
      width: 100%;
      height: 100%;
      font-size: 11px;
      font-stretch: condensed;
      label {
        position: absolute;
        transform: translate(-50%, -50%);
        &.narvik {
          left: 83.5%;
          top: 5%;
        }
        &.bodo {
          left: 71%;
          top: 11.4%;
        }
        &.mosjoen {
          left: 63%;
          top: 29%;
        }
        &.steinkjer {
          left: 59%;
          top: 45%;
        }
        &.grong {
          left: 62%;
          top: 42%;
        }
        &.trondheim {
          left: 42.2%;
          top: 49%;
        }
        &.hell {
          left: 49.2%;
          top: 50.7%;
        }
        &.meraker {
          left: 56%;
          top: 50.7%;
        }
        &.storen {
          left: 48%;
          top: 52.5%;
        }
        &.roros {
          left: 54.3%;
          top: 57%;
        }
        &.andalsnes {
          left: 21.6%;
          top: 56.7%;
        }
        &.dombas {
          left: 39.9%;
          top: 64%;
        }
        &.lillehamer {
          left: 38.7%;
          top: 69%;
        }
        &.gjovik {
          left: 43.3%;
          top: 72.7%;
        }
        &.hamar {
          left: 53.2%;
          top: 74%;
        }
        &.elverum {
          left: 56%;
          top: 71.5%;
        }
        &.kongsvinger {
          left: 60.6%;
          top: 77.3%;
        }
        &.roa {
          left: 44%;
          top: 76%;
        }
        &.bergen {
          left: 11.9%;
          top: 77.1%;
        }
        &.arna {
          left: 15%;
          top: 74.8%;
        }
        &.flam {
          left: 25.5%;
          top: 71.9%;
        }
        &.myrdal {
          left: 24%;
          top: 74.8%;
        }
        &.stavanger {
          left: 15.7%;
          top: 90%;
        }
        &.honefoss {
          left: 39.3%;
          top: 78%;
        }
        &.oslo {
          left: 47%;
          top: 79%;
        }
        &.sandvika {
          left: 39.5%;
          top: 80.5%;
        }
        &.hokksund {
          left: 36.2%;
          top: 82.5%;
        }
        &.notodden {
          left: 30.9%;
          top: 84.1%;
        }
        &.drammen {
          left: 46%;
          top: 83.4%;
        }
        &.ski {
          left: 51%;
          top: 82%;
        }
        &.sarpsborg {
          left: 55.7%;
          top: 87.3%;
        }
        &.kornsjo {
          left: 57.1%;
          top: 90.2%;
        }
        &.larvik {
          left: 41%;
          top: 90%;
        }
        &.skien {
          left: 35.6%;
          top: 87%;
        }
        &.fredrikstad {
          left: 48%;
          top: 89%;
        }
        &.tonsberg {
          left: 42.5%;
          top: 85.2%;
        }
        &.kristiansand {
          left: 24%;
          top: 98.5%;
        }
        &.arendal {
          left: 31.7%;
          top: 96.2%;
        }
        &.nelaug {
          left: 33.3%;
          top: 93.7%;
        }
      }
    }

    .current_year {
      position: absolute;
      top: 2%;
      left: 6%;
      font-size: 70px;
      font-weight: bold;
      color: #fff;
      background: linear-gradient(90deg, #00AAFF 0%, #0DDB40 105%);
      -webkit-text-fill-color: transparent;
      -webkit-background-clip: text;
    }

    .current_text {
      position: absolute;
      top: 16%;
      left: 7%;
      width: 45%;
      font-size: 16px;
      color: black;
      line-height: 1.1;
      word-break: break-word;
      white-space: pre-wrap;
      @media (max-width: 500px) {
        top: 15%;
        font-size: 13px;
      }
    }

    .legend {
      position: relative;
      font-size: 11px;
      font-weight: bold;
      display: flex;
      width: 100%;
      height: 50px;
      flex-flow: row nowrap;
      justify-content: space-around;
      align-items: center;
      line-height: 1.1;
      div {
        &.today {
          padding-left: 25px;
        }
        &.ertms {
          padding-left: 25px;
        }
        span {
          position: relative;
          padding-top: 3px;
          &::before {
            content: '';
            position: absolute;
            left: -22px;
            top: -1px;
            width: 16px;
            height: 16px;
            border-radius: 50%;
            background-color: inherit;
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Railroad.vue